import React from "react";
import { ShieldCheck } from "@phosphor-icons/react";

/**
 * "The No Surprises Guarantee" — closing trust block. Shown near the price
 * display on the Pricing section and near the pay button on Book Now.
 */
export default function NoSurprisesGuarantee({ testid = "no-surprises-guarantee", className = "" }) {
  return (
    <div
      data-testid={testid}
      className={`border-2 border-slate-900 bg-white p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 bg-sky-500 text-white flex items-center justify-center shrink-0">
          <ShieldCheck size={20} weight="fill" />
        </div>
        <div>
          <div className="text-[10px] font-extrabold tracking-[0.22em] uppercase text-sky-600">
            Our promise
          </div>
          <div className="font-display font-black text-xl sm:text-2xl text-slate-900 leading-tight">
            The No Surprises Guarantee
          </div>
        </div>
      </div>
      <p className="mt-3 text-sm sm:text-base text-slate-700 leading-relaxed">
        The price you see is the price you pay. No hidden fees, no surprise reclassification,
        no guessing games. Tell us the material, we tell you the number — before the bin even
        shows up.
      </p>
    </div>
  );
}
